// 商品詳細: ギャラリー・数量・送料無料メッセージ・色違い商品・仕様アコーディオン・ギフトボックス・今すぐ購入・固定購入バー（SP）
(function () {
  var root = document.querySelector('.pdp');
  if (!root) return;

  // ギフトボックス商品のページ: 対象商品（対応表のハンドル／タグ）のページから来たときだけ表示。それ以外は商品一覧へ戻す
  if (root.hasAttribute('data-gift-only')) {
    var targets = (root.dataset.giftOnlyTargets || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var fallback = root.dataset.giftOnlyFallback || '/collections/all';
    var leave = function () { window.location.replace(fallback); };
    var allow = function () { root.classList.remove('pdp--gift-only'); };
    var m = null;
    try { var ref = new URL(document.referrer); if (ref.origin === window.location.origin) m = ref.pathname.match(/^\/products\/([^\/?#]+)/); } catch (e) {}
    if (!m) { leave(); return; }
    fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
      .then(function (p) {
        var ok = targets.indexOf(p.handle) >= 0 || (p.tags || []).some(function (t) { return targets.indexOf(t) >= 0; });
        if (ok) allow(); else leave();
      })
      .catch(leave);
  }
  var price = parseInt(root.dataset.price, 10) || 0;
  var threshold = parseInt(root.dataset.threshold, 10) || 0;
  var variantId = root.dataset.variantId;
  var yen = function (n) { return '¥' + Math.round(n / 100).toLocaleString('ja-JP'); };

  // ギャラリー
  var main = document.getElementById('pdp-main-image');
  root.querySelectorAll('.pdp__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = t.dataset.full; }
      root.querySelectorAll('.pdp__thumb').forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  // 商品説明（管理画面の本文）内の画像: 原寸（数百KB〜）がそのまま出るので、遅延読み込み＋Shopify CDN の幅指定（1200px）に差し替える
  root.querySelectorAll('.pdp__desc img').forEach(function (img) {
    img.loading = 'lazy'; img.decoding = 'async';
    var src = img.getAttribute('src') || '';
    if (/(cdn\.shopify\.com\/s\/files\/|\/cdn\/shop\/files\/)/.test(src) && !/[?&]width=/.test(src)) img.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200');
  });

  // 数量（ページ内と固定バーの2か所を連動）
  var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-qty-input]'));
  var qtyInput = root.querySelector('form[data-type="add-to-cart-form"] [data-qty-input]') || qtyInputs[0];
  var getQty = function () { return Math.min(9, Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)); };
  var setQty = function (n) {
    var v = Math.min(9, Math.max(1, n));
    qtyInputs.forEach(function (i) { i.value = v; });
    updateShipping();
  };
  root.querySelectorAll('[data-qty-down]').forEach(function (b) { b.addEventListener('click', function () { setQty(getQty() - 1); }); });
  root.querySelectorAll('[data-qty-up]').forEach(function (b) { b.addEventListener('click', function () { setQty(getQty() + 1); }); });
  qtyInputs.forEach(function (i) { i.addEventListener('change', function () { setQty(parseInt(i.value, 10) || 1); }); });

  // 送料無料まであと○円: 現行サイト（snippets/shipping-incentive.liquid）と同じ要件
  //   残額 = しきい値 − （カート合計 ＋ この商品の価格×数量）。状態により5通りの文言
  var cartTotal = 0;
  var available = root.dataset.available !== 'false';
  var msg = root.querySelector('[data-shipping-msg]');
  function updateShipping() {
    if (!msg || !threshold) return;
    var sub = price * getQty();
    var effective = cartTotal + sub;
    var base = yen(threshold) + '（税込）以上のご注文で送料無料。';
    if (!available) {
      msg.textContent = 'ただいま売り切れ中です。再入荷の際はLINEでお知らせします';
    } else if (sub >= threshold) {
      msg.textContent = 'このご注文は送料無料でお届けします';
    } else if (cartTotal >= threshold) {
      msg.textContent = 'カート内のご注文は送料無料です';
    } else if (effective >= threshold) {
      msg.textContent = 'この商品を追加すると送料無料になります';
    } else if (cartTotal > 0) {
      msg.textContent = base + 'カート内と合わせてあと' + yen(threshold - effective) + 'です';
    } else {
      msg.textContent = base; // カートが空のときは残額を出さない（2026-10-20 指示）
    }
  }
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    .then(function (c) { cartTotal = c.total_price || 0; updateShipping(); }).catch(updateShipping);

  // 色違い商品（同じ line-* タグ）
  var colors = root.querySelector('[data-colors]');
  if (colors) {
    var tag = colors.dataset.lineTag, current = colors.dataset.current;
    fetch('/search?view=plist&type=product&options[unavailable_products]=show&options[prefix]=none&q=' + encodeURIComponent('tag:' + tag), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (items) {
        if (!Array.isArray(items) || items.length < 2) return;
        var me = items.filter(function (it) { return it.handle === current; })[0];
        var hasSize = items.some(function (it) { return it.size; });
        var colorItems = items, sizeItems = [];
        if (hasSize && me) {
          // サイズ展開のあるライン（切立プレート等）は現行サイトと同じ選び方:
          // カラー＝同じサイズの色違いだけ／サイズ＝同じ色のサイズ違いだけ
          colorItems = items.filter(function (it) { return (it.size || '') === (me.size || ''); });
          sizeItems = items.filter(function (it) { return it.size && (it.color || '') === (me.color || ''); });
          sizeItems.sort(function (a, b) { return (parseFloat(a.size) - parseFloat(b.size)) || String(a.size).localeCompare(String(b.size)); });
        }
        // 在庫ありを先に、同じ在庫状態の中では商品ハンドル順（例: 白 → 灰 → つや白 → 黒）
        colorItems.sort(function (a, b) { return (a.available === b.available) ? a.handle.localeCompare(b.handle) : (a.available ? -1 : 1); });
        if (colorItems.length >= 2) {
          var wrap = colors.querySelector('[data-swatches]');
          colorItems.forEach(function (it) {
            var label = it.color || it.title.split(/[ 　]/).pop();
            var a = document.createElement('a');
            a.href = '/products/' + it.handle;
            a.className = 'pdp__swatch' + (it.handle === current ? ' is-active' : '') + (it.available ? '' : ' is-soldout');
            a.innerHTML = '<span class="pdp__swatch-media"><img src="' + it.image + '" alt="" width="64" height="64" loading="lazy"></span><span class="pdp__swatch-label">' + label + (it.available ? '' : '（売り切れ）') + '</span>';
            wrap.appendChild(a);
          });
          colors.hidden = false;
        }
        var sizes = root.querySelector('[data-sizes]');
        if (sizes && sizeItems.length >= 2) {
          var sw = sizes.querySelector('[data-size-options]');
          sizeItems.forEach(function (it) {
            var a = document.createElement('a');
            a.href = '/products/' + it.handle;
            a.className = 'pdp__size-opt' + (it.handle === current ? ' is-active' : '') + (it.available ? '' : ' is-soldout');
            if (it.handle === current) a.setAttribute('aria-current', 'true');
            a.innerHTML = it.size + (it.available ? '' : '<span class="pdp__size-soldout">（売り切れ）</span>');
            sw.appendChild(a);
          });
          sizes.hidden = false;
        }
      }).catch(function () {});
  }

  // レビューを書く → Judge.me の投稿フォーム（モーダル）。スクリプト未読込時は href="#judgeme"（Judge.me が読み込み後に開く）
  // レビュー 0 件の商品は Judge.me がウィジェット HTML（judgeme.widget）を書いていないため、
  // Judge.me のテンプレートで見出し＋フォーム枠を作ってから初期化し直す
  function ensureJdgmForm() {
    var w = document.querySelector('[data-jdgm-widget] .jdgm-review-widget');
    var j = window.jdgm;
    if (!w || !j || !j.$ || !j.templates || w.querySelector('.jdgm-rev-widg')) return;
    var $w = j.$(w);
    $w.removeClass(j.DONE_SETUP_WIDGET_CLASS);
    $w.append(j.templates.header());
    try { j.buildStarsFor($w.find('.jdgm-rev-widg__summary-stars'), 0); } catch (err) {}
    j.initializeWidgets();
  }
  // フォームの体裁（デザイン: handoff/mocks-src/15_レビュー投稿フォーム.dc.html）: 送信ボタンの文言、横の「キャンセル」
  function decorateJdgmForm() {
    var form = document.querySelector('[data-jdgm-widget] .jdgm-form');
    if (!form || form.dataset.decorated) return;
    var submit = form.querySelector('.jdgm-submit-rev');
    if (!submit) return;
    submit.value = 'レビューを送信する';
    var actions = document.createElement('div');
    actions.className = 'pdp__jdgm-actions';
    submit.parentNode.insertBefore(actions, submit);
    actions.appendChild(submit);
    var cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.className = 'pdp__jdgm-cancel';
    cancel.textContent = 'キャンセル';
    cancel.addEventListener('click', closeJdgmForm);
    actions.appendChild(cancel);
    form.dataset.decorated = '1';
  }
  function closeJdgmForm() {
    var sec = document.querySelector('[data-reviews]');
    var link = document.querySelector('[data-jdgm-widget] .jdgm-write-rev-link');
    if (link && link.classList.contains('close-form-btn')) link.click(); // Judge.me 側のフォームを閉じた状態に戻す
    if (sec) {
      sec.classList.remove('is-jdgm-form-open');
      var summary = sec.querySelector('.pdp__reviews-summary');
      if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  var closeBtn = document.querySelector('[data-close-review]');
  if (closeBtn) closeBtn.addEventListener('click', closeJdgmForm);
  var writeBtn = document.querySelector('[data-write-review]');
  if (writeBtn && !writeBtn.hasAttribute('data-external')) {
    writeBtn.addEventListener('click', function (e) {
      ensureJdgmForm();
      var link = document.querySelector('[data-jdgm-widget] .jdgm-write-rev-link');
      if (!link) return;
      e.preventDefault();
      var sec = document.querySelector('[data-reviews]');
      if (sec) sec.classList.add('is-jdgm-form-open');
      if (!link.classList.contains('close-form-btn')) link.click(); // すでに開いていれば Judge.me 側は触らない
      setTimeout(function () {
        decorateJdgmForm();
        var card = document.querySelector('[data-jdgm-widget]');
        if (card && card.offsetParent) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    });
  }
  // すべてのレビューを見る → Judge.me 本体の一覧（ページ送り付き）に切り替え
  function openAllReviews() {
    var sec = document.querySelector('[data-reviews]');
    if (sec) sec.classList.add('is-jdgm-open');
    var btn = document.querySelector('[data-more-reviews]');
    if (btn) btn.hidden = true;
  }
  var moreBtn = document.querySelector('[data-more-reviews]');
  if (moreBtn) moreBtn.addEventListener('click', openAllReviews);
  // ?reviews=all で最初から Judge.me 本体の一覧（ページ送り付き）を開く（確認用・レビューページへの深いリンク用）
  if (/[?&]reviews=all(&|$)/.test(location.search) && document.querySelector('[data-jdgm-widget]')) {
    openAllReviews();
    var rs = document.querySelector('[data-reviews]');
    if (rs) setTimeout(function () { rs.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
  }

  // 仕様アコーディオン
  root.querySelectorAll('.pdp__spec-head').forEach(function (h) {
    h.addEventListener('click', function () {
      var open = h.getAttribute('aria-expanded') === 'true';
      h.setAttribute('aria-expanded', String(!open));
      h.querySelector('.pdp__spec-mark').textContent = open ? '+' : '−';
      var body = document.getElementById(h.getAttribute('aria-controls'));
      if (body) body.hidden = open;
    });
  });

  // ギフトボックス: チェック時はカート追加の直前に、ギフトボックス商品を同数量で別行として追加する
  var gift = root.querySelector('[data-gift-box]');
  var giftAdded = false;
  function addGiftBox() {
    if (!gift || !gift.checked) return Promise.resolve();
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: gift.dataset.variantId, quantity: getQty() }) })
      .then(function (r) { if (!r.ok) throw new Error('gift add failed'); });
  }
  var formEl = root.querySelector('form[data-type="add-to-cart-form"]');
  if (gift && formEl) formEl.addEventListener('submit', function (e) {
    if (!gift.checked || giftAdded) { giftAdded = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    addGiftBox().catch(function () {}).then(function () { giftAdded = true; formEl.requestSubmit(); });
  }, true);

  // 今すぐ購入する: カートに追加してチェックアウトへ（ページ内と固定バーで共通）
  function buyNow(btn) {
    btn.disabled = true;
    addGiftBox().catch(function () {})
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: getQty() }) }); })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; });
  }
  root.querySelectorAll('[data-buy-now], [data-sticky-buy]').forEach(function (b) { b.addEventListener('click', function () { buyNow(b); }); });

  // 固定購入バー: ページ内の購入ボタンが画面外に出たときだけ表示。カートに入れるはページ内フォームの送信を代行
  var sticky = root.querySelector('[data-sticky]');
  var form = root.querySelector('form[data-type="add-to-cart-form"]');
  var stickyAdd = root.querySelector('[data-sticky-add]');
  if (stickyAdd && form) stickyAdd.addEventListener('click', function () {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.click();
  });
  if (sticky) {
    var target = root.querySelector('.pdp__buy .pdp__buttons') || form;
    var show = function (on) { sticky.classList.toggle('is-visible', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { show(!entries[0].isIntersecting); }, { threshold: 0 }).observe(target);
    } else {
      show(true);
    }
  }
})();
